export default __webpack_public_path__ + "static/media/logoTAP.c704d1e3.svg";